/* eslint-disable react/sort-comp */
import classNames from 'classnames';
import i18n from 'i18next';

import {
  EditColumns,
  Footer,
  Loader,
  Modal,
  NotifyContainer,
  ScrollToTop,
  NoClient,
  ShareModal,
  ApiErrorModal,
  CrashScreen,
} from 'Components';
import auth from 'helpers/auth';
import { isIE } from 'helpers/detectEdgeIE';
import PropTypes from 'prop-types';
import Fetch from 'helpers/fetch';
import { parseColumnData } from 'helpers/key-pairs';
import { buildUrl } from 'helpers/misc';
import { cleanSearchParams, urlSearchToObject } from 'helpers/urlSearchParams';
import { fetchStorageConditions, fetchServiceLevel, fetchOrderSupplies, fetchQCTypeOptions } from 'helpers/initialize';

import log from 'loglevel';
import React, { Component, Fragment, Suspense } from 'react';
import { hot } from 'react-hot-loader';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';

import loadAppConfig from 'src/redux/actions/appConfig';
import loadUserInfo from 'src/redux/actions/userInfo';
import { loadSubmissionTypes } from 'src/redux/actions/utilities';
import { connect } from 'react-redux';
import './App.css';
import AppContext from './AppContext';
import {
  CLIENTS,
  CUSTOMIZETABLE,
  SIGN_OUT,
  SUBMISSIONTYPES,
  TERMS,
  USERINFO,
  FILTERFIELDS,
  CONFIGURATION,
  SITEPROVINCE,
} from './constants/apis';
import tables from './constants/tables';
import tabs from './constants/tabs';
import {
  Dash,
  Head,
  Invoices,
  Jobs,
  Login,
  Nav,
  Overview,
  Supplies,
  Templates,
  ForgotPassword,
  Logout,
  Registration,
  ResourcesIframe,
  PrepaidRequest,
} from './containers';
import history from './history';
import theme from './constants/theme';
import LoginLayout from './layouts/Login';
import stickyAASamplesHeaders from './containers/Forms/AdditionalAnalysis/_helpers/stickyHeaders';
import DeletionContext from './MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from './MultiDeletionFunctionality/@state_manager/actions';

const AdditionalAnalysis = React.lazy(() => import('./containers/Forms/AdditionalAnalysis/AdditionalAnalysis'));
const Forms = React.lazy(() => import('./containers/Forms/Forms'));
const Reports = React.lazy(() => import('./containers/Reports/Reports'));
const ReportsForm = React.lazy(() => import('./containers/ReportsForm/ReportsForm'));
const Terms = React.lazy(() => import('./containers/Terms/Terms'));
const Privacy = React.lazy(() => import('./containers/Privacy/Privacy'));
const MyAccount = React.lazy(() => import('./containers/MyAccount/MyAccount'));
const EmailNotifications = React.lazy(() => import('./containers/EmailNotifications/EmailNotifications'));
const InvoicesPaymentConfirmation = React.lazy(() =>
  import('./containers/InvoicesPaymentConfirmation/InvoicesPaymentConfirmation'),
);
const InvoicesPaymentDetails = React.lazy(() => import('./containers/InvoicesPaymentDetails/InvoicesPaymentDetails'));
const InvoicesPaymentSummary = React.lazy(() => import('./containers/InvoicesPaymentSummary/InvoicesPaymentSummary'));
const Confirmation = React.lazy(() => import('./containers/Confirmation/Confirmation'));
const JobsDetail = React.lazy(() => import('./containers/JobsDetail/JobsDetail'));
const LoginAsAdmin = React.lazy(() => import('./containers/LoginAsAdmin/LoginAsAdmin'));

const ManageAccessCurrentUsers = React.lazy(() =>
  import('./containers/ManageAccess/ManageAccessCurrentUsers/ManageAccessCurrentUsers'),
);
const ManageAccessInactiveUsers = React.lazy(() =>
  import('./containers/ManageAccess/ManageAccessInactiveUsers/ManageAccessInactiveUsers'),
);
const ManageAccessUser = React.lazy(() => import('./containers/ManageAccess/ManageAccessUser/ManageAccessUser'));
const ManageAccessUserAccess = React.lazy(() =>
  import('./containers/ManageAccess/ManageAccessUserAccess/ManageAccessUserAccess'),
);
const SplitReportRequestForm = React.lazy(() =>
  import('./containers/Forms/SplitReportRequestForm/SplitReportRequestForm'),
);

const isEmpty = (obj) => Object.keys(obj).length > 0 && obj.constructor === Object;

const getDeviceIndex = () => {
  if (isIE()) return 1;

  if (document.documentElement.clientWidth <= 1024) return 0;
  return 1;
};
class App extends Component {
  static contextType = DeletionContext;
  constructor(props) {
    super(props);
    this.isRedirectionNeeded = !['/login', '/register', '/forgot', '/'].includes(history.location.pathname);
    this.isPayingInvoice = ['/PayInvoice', '/PayInvoice/GetInvoice'].includes(history.location.pathname);
    this.unauthorizedRoutes = ['/register', '/forgot'];
    this.freshState = {
      footerDesktopExpanded: false,
      isFooterHidden: false,
      isInitialized: false,
      hasAcceptedTerms: null,
      isModalActive: false,
      isLoggedInAsAdmin: false,
      isNavCollapsed: false,
      isHeadButtonVisible: true,
      isCreatingObject: false,
      isGlobalLoaderShowing: false,
      isSamplesLoading : false,
      isChangingObject: false,
      isTutorialShowing: false,
      hasManageAccess: false,
      hasLoginAsAdmin: false,
      isManuallyLoggedIn: false,
      isPrepaidOrder: false,
      clients: {
        isLoading: true,
        isPrepaid: false,
        invoiceViaRpt:false,
        abortController: new AbortController(),
        data: [],
        options: [],
        value: '',
        index: 0,
      },
      userInfo: {
        IsInternalUser: false,
        UserName: '',
      },
      filterFields: {
        isLoading: true,
        options: [],
      },
      submissionTypes: {},
      submissionTypeOptions: [],
      orderSupplies: [],
      settingTableCode: null,
      filterFieldValue: '',
      filterItemValue: '',
      headTitle: '',
      headSubTitle: '',
      headDescription: '',
      formIndex: undefined,
      isAPIErrorModalOpen: false,
      hidePageErrorDiscription: false,
      apiErrorMessage: '',
      isApiErrorModalCloseable: false,
      ShelfLifeStorageConditions: [],
      QcTypeOptions: [],
      ChangeLogComments: undefined,
      isAlreadyRedirected: false,
      isAlreadyRedirectedForPasswordChange: null,
      redirectionURL: this.isRedirectionNeeded ? `${history.location.pathname}${history.location.search}` : undefined,
      shareCode: null,
      shareId: null,
      isAppGoingToCrash: false,
      isSupplyWarningON: false,
      PrepaidOrderOverrideReason:'',
      ...tables,
    };

    this.state = {
      deviceIndex: getDeviceIndex(),
      isLoggedIn: auth.isAuthenticated() || auth.isRefreshTokenActive(),
      ...this.freshState,
    };

    this.landingPages = [
      'templates',
      'submissions',
      'custom-reports',
      'orders',
      'invoices',
      'jobs',
      'additional-analysis',
      'split-report',
    ];
    this.overviewTables = ['overviewJobs', 'overviewTemplates', 'overviewInvoices', 'overviewOrders'];

    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.setAppState = this.setAppState.bind(this);
    this.onAPIError = this.onAPIError.bind(this);
    this.onCopyOrderError = this.onCopyOrderError.bind(this);
    this.onResize = this.onResize.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.setHeadTitle = this.setHeadTitle.bind(this);
    this.initialize = this.initialize.bind(this);

    this.fetchStorageConditions = fetchStorageConditions.bind(this);
    this.fetchServiceLevel = fetchServiceLevel.bind(this);
    this.fetchOrderSupplies = fetchOrderSupplies.bind(this);
    this.fetchQCTypeOptions = fetchQCTypeOptions.bind(this);
    this.getPrepaidStatus = this.getPrepaidStatus.bind(this);
    this.handleRegionLocalStorage();
  }

  componentDidMount() {
    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;

    window.addEventListener('resize', this.onResize);
    const isLogInPath = history.location.pathname === '/login';

    if (this.state.isLoggedIn && !isLogInPath) {
      this.initialize();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const isNewlyLoggedIn = this.state.isLoggedIn && !prevState.isLoggedIn;
    const isNewlyLoggedInAsAdmin = this.state.isLoggedInAsAdmin && !prevState.isLoggedInAsAdmin;
    const hasChosenClientNumber = !this.state.userInfo.IsInternalUser || this.state.userInfo.ClientNumber !== '';

    if ((isNewlyLoggedIn || isNewlyLoggedInAsAdmin) && !this.state.isInitialized) {
      this.initialize();
    }

    if (prevState.userInfo.ClientNumber !== this.state.userInfo.ClientNumber) {
      let isPrepaid = false;
      let invoiceViaRpt = false;
      if (this.state.userInfo.ClientNumber !== '') {
        const client = (this.state.clients.data || []).find((x) => x.ClientNumber === this.state.userInfo.ClientNumber);
        isPrepaid = client !== undefined && client.IsPrepaid;
        invoiceViaRpt = client !== undefined && client.InvoiceViaRpt;
      }
      this.setState((prState) => {
        return {
          ...prState,
          clients: {
            ...prState.clients,
            isPrepaid,
            invoiceViaRpt,
          },
        };
      });
      if (isPrepaid !== this.state.clients.isPrepaid) {
        this.fetchTableKeyPairs('submittedTab');
        this.fetchTableKeyPairs('receivedJobs');
      }
    }

    if (this.state.isInitialized && this.state.isLoggedIn) {
      const filterItemChanged = this.state.filterItemValue !== prevState.filterItemValue;
      const prevClientNumber = prevState.userInfo.ClientNumber;
      const currClientNumber = this.state.userInfo.ClientNumber;
      const clientNumberChanged = currClientNumber !== prevClientNumber;

      if ((filterItemChanged || clientNumberChanged) && hasChosenClientNumber) {
        let route = history.location.pathname.split('/')[1];

        if (route === 'supplies') route = 'orders';
        if (route === 'submissions') route = 'jobs';
        // Custom reports needed in landingPages but not here
        if (route === 'custom-reports') route = '';
        if (route === 'additional-analysis') route = '';
        if (route === 'split-report') route = 'split-report';
        if (!this.landingPages.includes(route)) route = '';

        [...this.overviewTables, route].filter((item) => item !== '').forEach((table) => this.fetch(table));
      }

      if (clientNumberChanged) {
        Fetch.Put(USERINFO, this.state.userInfo);
      }

      Object.keys(tables).forEach((table) => {
        const { shouldLoad, pageNumber } = this.state[table];
        const oldPageNumber = prevState[table].pageNumber;
        if ((shouldLoad && !prevState[table].shouldLoad) || pageNumber !== oldPageNumber) {
          this.fetch(table);
        }
      });
    }

    if (this.state.isNavCollapsed !== prevState.isNavCollapsed) {
      this.setAppState({ isTutorialShowing: false });
    }
  }

  componentDidCatch() {
    this.setState({ isAppGoingToCrash: true });
  }

  onResize() {
    clearTimeout(this.resizeId);
    if (document.getElementById('app') !== null) {
      this.resizeId = setTimeout(() => document.getElementById('app').classList.remove('app--resizing'), 400);
      document.getElementById('app').classList.add('app--resizing');

      const deviceIndex = getDeviceIndex();
      if (deviceIndex !== this.state.deviceIndex) {
        this.setState({ deviceIndex });
      }
    }
  }

  onAPIError(response, isApiErrorModalCloseable, shouldRedirectToBV) {
    if (response) {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then((err) => {
          this.setState({
            isAPIErrorModalOpen: true,
            apiErrorMessage: err.Message,
            isApiErrorModalCloseable,
            shouldRedirectToBV,
          });
        });
      }
    }
    return this.setState({
      isAPIErrorModalOpen: true,
      isApiErrorModalCloseable,
    });
  }

  onCopyOrderError(response, isApiErrorModalCloseable, shouldRedirectToBV) {
    if (response) {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json().then((err) => {
          this.setState({
            hidePageErrorDiscription: true,
            isAPIErrorModalOpen: true,
            apiErrorMessage: err.Message,
            isApiErrorModalCloseable,
            shouldRedirectToBV,
          });
        });
      }
    }
    return this.setState({
      isAPIErrorModalOpen: true,
      isApiErrorModalCloseable,
      hidePageErrorDiscription: true,
    });
  }

  setAppState(newState, callback) {
    this.setState(newState, callback);
  }

  getPrepaidStatus() {
    return this.state.clients.isPrepaid && this.state.userInfo.IsInternalUser;
  }

  setHeadTitle(title) {
    const isSearching = Object.keys(urlSearchToObject(history.location.search)).length > 0;
    let headTitle = title;

    if (this.state.filterItemValue) {
      headTitle = `${title} - ${this.state.filterItemValue}`;
    }
    if (isSearching) {
      headTitle = `${i18n.t('head:searchResultsFor')} ${title}`;
    }

    this.setState({ headTitle });
  }
  filterDataList(dataList, table) {
    switch (table) {
      case 'submittedTab':
        return dataList.filter((x) =>
          x.DataField !== 'PrepaidRequest' &&
          x.DataField !== 'OrderNumber' &&
          x.DataField !== 'Type'
        );
      case 'receivedJobs':
        return dataList.filter((x) =>
          x.DataField !== 'OrderNumber'
        );
      default:
        return dataList;
    }
  }
  fetchClients() {
    return new Promise((resolve, reject) => {
      this.state.clients.abortController.abort();
      const abortController = new AbortController();

      this.setState((prevState) => {
        return {
          clients: {
            ...prevState.clients,
            isLoading: true,
            abortController,
          },
        };
      });

      Fetch.Get(`${CLIENTS}?ClientsOnly=Y`, { signal: abortController.signal })
        .then((resp) => resp.json())
        .then((data) => data.DataList)
        .then((data) => {
          const options = data.map((item) => ({
            value: item.ClientNumber,
            label:
              item.FacilityName === ''
                ? `${item.ClientNumber.trim()} \n${item.CompanyName.trim()}`
                : `${item.ClientNumber.trim()} \n${item.CompanyName.trim()} \n${item.FacilityName.trim()}`,
          }));

          this.setState((prevState) => {
            return {
              clients: {
                ...prevState.clients,
                isLoading: false,
                abortController,
                options,
                data,
                value: '',
                index: 0,
              },
            };
          });

          return resolve();
        })
        .catch(reject);
    });
  }

  fetch(table) {
    if (!this.state[table]) {
      return;
    }

    this.state[table].abortController.abort();

    if (this.state[table].keys === undefined) {
      this.fetchFull(table);
    } else if (!this.state[table].handleDataManually) {
      this.fetchData(table);
    }
  }

  fetchFull(table) {
    const abortController = new AbortController();

    this.setState((prevState) => ({
      [table]: {
        ...prevState[table],
        abortController,
        isLoading: true,
        shouldLoad: false,
      },
    }));

    this.fetchTableKeyPairs(table);
  }

  fetchTableKeyPairs(table) {
    return new Promise((resolve, reject) => {
      const abortController = new AbortController();
     
      const parameters = {
        viewCode: this.state[table].viewCode,
        applicationCode: 'CP',
      };

      Fetch.Get(buildUrl(CUSTOMIZETABLE, parameters), {
        signal: abortController.signal,
      })
        .then((response) => response.json())
        .then((data) => {
          const responseData =
            (!this.state.clients.isPrepaid)
              ? {
                ...data, DataList: this.filterDataList(data.DataList, table)
              }
              : data;
          const options = parseColumnData(responseData);
          if (this.state[table].handleDataManually) {
            this.setState((prevState) => ({
              [table]: {
                ...prevState[table],
                ...options,
              },
            }));
          } else {
            this.fetchData(table, options);
          }
          return resolve();
        })
        .catch((err) => {
          log.error(err);
          if (!!err.response && err.response.status == '401') {
            history.push('/login');
            window.location.reload();
          }
        });
    });
  }

  fetchData(table, options = {}) {
    const abortController = new AbortController();
    const selectedTable = this.state[table];

    const requiredFields = selectedTable.requiredFields || [];

    const { globalSearchParams } = selectedTable;

    const hasGlobalSearchParams = globalSearchParams === undefined ? false : isEmpty(globalSearchParams);

    const filterItemValue = this.state.filterItemValue === '' ? undefined : this.state.filterItemValue;

    const searchParams = hasGlobalSearchParams
      ? {}
      : cleanSearchParams({
          ...selectedTable.searchParams,
          [this.state.filterFieldValue]: filterItemValue,
        });

    let keys = options.keys || this.state[table].keys;

    // We have 2 different tables, with seperate keys for the jobs
    if (table === 'jobs') {
      keys = this.state.jobs.tabIndex === 0 ? this.state.receivedJobs.keys : this.state.submittedTab.keys;

      if (hasGlobalSearchParams) {
        keys = [...keys, this.state.samples.keys];
      }
    }
    // We have 2 different tables, with seperate keys for the prepaidrequest
    if (table === 'prepaidrequest') {
      keys = this.state.prepaidrequest.tabIndex === 4 ? this.state.prepaidAll.keys : this.state.submittedTab.keys;    
    }

    keys = Array.from(new Set([...keys, ...requiredFields]));

    const params = {
      ...searchParams,
      ...globalSearchParams,
      sort: selectedTable.sort,
      fields: keys.join(','),
      pageNumber: selectedTable.pageNumber - 1,
      pageSize: selectedTable.pageSize,
    };

    if (this.state.userInfo.IsInternalUser) {
      if (!params.ClientNumber) {
        params.ClientNumber = this.state.userInfo.ClientNumber;
      }
    }

    this.setState((prevState) => ({
      [table]: {
        ...prevState[table],
        ...options,
        abortController,
        isLoading: true,
        data: [],
        shouldLoad: false,
      },
      prevTab: table.includes('overview') ? '' : (table) ==='orders' ?'supplies' : table,
    }));
    const URL = buildUrl(selectedTable.URL, params);

    Fetch.Get(URL, { signal: abortController.signal })
      .then((response) => response.json())
      .then((data) => {
        this.setState((prevState) => ({
          [table]: {
            ...prevState[table],
            data: data.DataList || [],
            isLoading: false,
            isDeleting: false,
            totalItems: data.MatchCriteriaCount || 0,
            Message: data.Message,
          },
        }));
      })
      .catch((err) => {
        !err.aborted && log.error(err);
        if (!!err.response && err.response.status == '401') {
          history.push('/login');
          window.location.reload();
        }
      })
      .finally(() =>
        this.setState((prevState) => ({
          [table]: {
            ...prevState[table],
            isDeleting: false,
          },
        })),
      );
  }



  async initialize() {
    if ('prepaideCoC' in (urlSearchToObject(history.location.search) || {})) {
      return;
    }

    await Fetch.HydrateIdentityToken();
    const fetchUserInfo = () =>
      new Promise((resolve, reject) => {
        Fetch.Get(buildUrl(USERINFO, { moreInfo: true }))
          .then((response) => response.json())
          .then((data) => resolve(data.DataItem))
          .catch(reject);
      });

    const fetchTerms = Fetch.Get(TERMS)
      .then((res) => res.json())
      .catch((err) => {
        throw err;
      });

    const fetchAppConfig = Fetch.Get(CONFIGURATION)
      .then((res) => res.json())
      .catch((err) => {
        throw err;
      });

    const fetchSubmissionTypes = Fetch.Get(SUBMISSIONTYPES)
      .then((res) => res.json())
      .catch((err) => {
        throw err;
      });

    const fetchSiteProvince = Fetch.Get(SITEPROVINCE)
      .then((res) => res.json())
      .catch((err) => {
        throw err;
      });

    const fetchFilterFields = Fetch.Get(FILTERFIELDS)
      .then((resp) => resp.json())
      .then((data) => {
        const options = (data.DataList || []).map((x) => ({
          value: x.DataField,
          label: x.Description,
        }));

        this.setState((prevState) => ({
          filterFields: {
            ...prevState.filterFields,
            options,
            isLoading: false,
          },
        }));
        this.setState({
          filterFieldValue: options[0].value,
        });
      });

    let reSetTableKeys = {};

    Object.keys(tables)
      .filter((table) => !this.state[table].handleDataManually)
      .map((item) => ({
        [item]: {
          ...tables[item],
          keys: undefined,
        },
      }))
      .forEach((item) => {
        reSetTableKeys = {
          ...reSetTableKeys,
          ...item,
        };
      });

    return new Promise((resolve, reject) => {
      Promise.all([
        fetchAppConfig,
        fetchUserInfo(),
        fetchTerms,
        fetchSubmissionTypes,
        fetchSiteProvince,
        this.fetchOrderSupplies(),
        this.fetchClients(),
        this.fetchServiceLevel(),
        this.fetchStorageConditions(),
        this.fetchQCTypeOptions(),
        this.fetchTableKeyPairs('sampleDetails'),
        this.fetchTableKeyPairs('jobDetails'),
        this.fetchTableKeyPairs('parameters'),
        this.fetchTableKeyPairs('jobFiles'),
        this.fetchTableKeyPairs('observations'),
        this.fetchTableKeyPairs('reportJobs'),
        this.fetchTableKeyPairs('receivedJobs'),
        this.fetchTableKeyPairs('ordersSearch'),
        this.fetchTableKeyPairs('submittedTab'),
        this.fetchTableKeyPairs('prepaidAll'),
        this.fetchTableKeyPairs('additionTab'),
        this.fetchTableKeyPairs('splitReport'),
        fetchFilterFields,
      ])
        .then(([appConfig, userInfo, terms, submissionTypes, siteProvince]) => {
          this.props.loadAppConfig(appConfig.DataItem);
          i18n.changeLanguage(userInfo.UserLanguage);
          this.dispatch({
            type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
            payload: { userInfo },
          });

          this.setState(() => {
            return {
              hasAcceptedTerms: terms.DataItem.AcceptedNewTermsAndConditions,
              termsAndConditions: terms.DataItem.NewTermsAndConditions,
              userInfo,
              isSupplyWarningON: appConfig.DataItem.CPSupplyWarning,
              isTemplateWarningON: appConfig.DataItem.CPTemplateWarning,
              isSubmissionWarningON: appConfig.DataItem.CPSubmissionWarning,

              hasManageAccess: !userInfo.IsInternalUser && userInfo.IsSuperUser,
              hasLoginAsAdmin: userInfo.IsInternalUser && userInfo.IsSuperUser,
              isInitialized: true,
              submissionTypes: submissionTypes.DataList,
              submissionTypeOptions: (submissionTypes.DataList || []).map((x) => ({
                value: x.Id,
                label: x.Description,
                code: x.SubmissionType,
              })),
              submissionTypes: submissionTypes.DataList,
              submissionTypeOptions: (submissionTypes.DataList || []).map((x) => ({
                value: x.Id,
                label: x.Description,
                code: x.SubmissionType,
              })),
              siteProvince: siteProvince.DataList,
              siteProvinceOptions: (siteProvince.DataList || []).map((x) => ({
                value: x.PROV_C,
                label: userInfo.UserLanguage === 'E' ? x.EN_PROV : x.FR_PROV,
              })),
              ...reSetTableKeys,
            };
          });

          this.props.loadSubmissionTypes(submissionTypes.DataList);
          this.props.loadUserInfo(userInfo);
          return resolve();
        })
        .catch((error) => {
          this.onAPIError(error && error.response, false, true);
          return reject();
        });
    });
  }

  handleLogin() {
    this.setState(
      {
        isLoggedIn: true,
        isManuallyLoggedIn: true,
      },
      () => history.push('/'),
    );
  }

  handleLogout() {
    Object.keys(tables).forEach((table) => this.state[table].abortController.abort());
    this.state.clients.abortController.abort();
    this.setState({
      ...this.freshState,
      isLoggedIn: false,
      isAlreadyRedirected: false, // prevState.isAlreadyRedirected, <- why?
    });

    Fetch.Get(SIGN_OUT, {
      headers: {
        IdentityToken: window.localStorage.getItem('IdentityToken'),
      },
    }).catch((err) => log.error(err));
    localStorage.removeItem('IdentityToken');
    localStorage.removeItem('RefreshToken');
    localStorage.removeItem('Region');
    localStorage.removeItem('messageShown');
    this.handleRegionLocalStorage();
  }

  handleScroll(e) {
    const pathname = history.location.pathname;
    if (!e.target.classList.contains('app__content__body')) return;
    if (pathname === '/') return;
    if (this.state.deviceIndex === 0) return;
    let route = pathname.split('/')[1];
    if (route === 'supplies') route = 'orders';
    if (!this.landingPages.includes(route)) return;

    this.handleHeadButtonVisible(e);
    stickyAASamplesHeaders(e);

    const stickyHeaders = document.querySelectorAll(`
      .power-table thead tr th,
      .template-table__invoices__th,
      .power-table-right__head,
      .power-table-left__head
    `);

    let X;
    let Y;
    let translateX;
    let translateY;
    let translateXY;

    const { scrollTop } = e.target;
    let offsetY = pathname.includes('invoices') ? 190 : 99;
    Y = scrollTop > offsetY ? scrollTop - offsetY : 0;
    translateY = `translateY(${Y}px)`;

    for (let i = 0; i < stickyHeaders.length; i++) {
      stickyHeaders[i].style.transform = translateY;
      stickyHeaders[i].style.msTransform = translateY;
    }

    // Begin translating headers on FormsSamplesDesktop

    const isStep3GridCalNeeded =
      this.state.formIndex === 2 && (pathname.includes('templates') || pathname.includes('submission'));

    if (isStep3GridCalNeeded) {
      const fixedVerticalElts = document.querySelectorAll('.forms-samples-desktop-thead__tr th:nth-child(n+6)');

      const fixedHorizontalElts = document.querySelectorAll(
        '.forms-samples-desktop-tr td:nth-child(-n+5), .forms-samples-desktop-tfoot td:nth-child(-n+5), .popover',
      );

      const fixedBothElts = document.querySelectorAll(
        '.forms-samples-desktop-thead__tr th:nth-child(-n+5), .forms-samples-desktop__composite, .forms-samples-desktop__multi-delete',
      );

      if (e.target.tagName.toLowerCase() === 'textarea') return;
      offsetY = 333;
      let scrollLeft = 0;

      scrollLeft = document.getElementsByClassName('forms-samples-desktop__table')[0].scrollLeft;

      if (scrollTop !== 0 || scrollLeft !== 0) {
        X = scrollLeft;
        Y = scrollTop > offsetY ? scrollTop - offsetY : 0;

        translateX = `translate(${X}px,0)`;
        translateY = `translate(0,${Y}px)`;
        translateXY = `translate(${X}px,${Y}px)`;

        for (let i = 0; i < fixedHorizontalElts.length; i += 1) {
          fixedHorizontalElts[i].style.transform = translateX;
        }
        for (let i = 0; i < fixedVerticalElts.length; i += 1) {
          fixedVerticalElts[i].style.transform = translateY;
        }
        for (let i = 0; i < fixedBothElts.length; i += 1) {
          fixedBothElts[i].style.transform = translateXY;
        }
      }
    }
  }

  handleRegionLocalStorage() {
    if (!this.state.isLoggedIn) {
      const urlParams = new URLSearchParams(history.location.search);
      if (!localStorage.getItem('Region')) {
        localStorage.setItem('Region', JSON.stringify(urlParams.get('Region')));
      } else if (localStorage.getItem('Region') !== JSON.stringify(urlParams.get('Region'))) {
        localStorage.setItem('Region', JSON.stringify(urlParams.get('Region')));
      }
    }
  }

  handleHeadButtonVisible(e) {
    const url = window.location.pathname || '';
    const requiredHeadButtonRegexPath = ['new', 'edit', 'confirmation', 'copy'];
    if (!requiredHeadButtonRegexPath.some((item) => url.includes(item))) return;
    const isHeadButtonVisible = e.target.scrollTop < 104;
    if (this.state.isHeadButtonVisible !== isHeadButtonVisible) {
      this.setState({ isHeadButtonVisible });
    }
  }

  render() {
    const shouldRedirectToTerms =
      this.state.isLoggedIn && this.state.hasAcceptedTerms === false && history.location.pathname !== '/terms';

    const shouldRedirectToLogin =
      !this.state.isLoggedIn &&
      !history.location.pathname.includes('login') &&
      !this.isPayingInvoice &&
      !this.unauthorizedRoutes.includes(history.location.pathname);

    const shouldRedirectToAccounts = this.state.isLoggedIn && localStorage.getItem('RedirectToAccounts') === 'true';

    // forcefully redirect to terms and condition
    if (shouldRedirectToTerms) {
      history.replace('/terms');
    }

    // when user is trying to access the different route but not logged in
    // once user log in then redirect to saved url in redirectionURL
    // and make isAlreadyRedirected: true. so it can redirect once
    if (
      !shouldRedirectToTerms &&
      this.state.isLoggedIn &&
      this.state.redirectionURL !== undefined &&
      !this.state.isAlreadyRedirected
    ) {
      const redirect = this.state.redirectionURL;
      this.setState(
        {
          redirectionURL: undefined,
          isAlreadyRedirected: true,
        },
        () => history.push(redirect),
      );
    }

    // when user has accepted terms and condition and should redirect to my account
    if (
      this.state.hasAcceptedTerms !== null &&
      this.state.hasAcceptedTerms &&
      shouldRedirectToAccounts &&
      this.state.isAlreadyRedirectedForPasswordChange === null
    ) {
      this.setState(
        {
          redirectionURL: undefined,
          isAlreadyRedirectedForPasswordChange: true,
        },
        () => history.push('/my-account'),
      );
    }

    const sharedProps = {
      deviceIndex: this.state.deviceIndex,
      appState: this.state,
      setAppState: this.setAppState,
      isGlobalLoaderShowing: this.state.isGlobalLoaderShowing,
      isSamplesLoading: this.state.isSamplesLoading,
      isTutorialShowing: this.state.isTutorialShowing,
      onAPIError: this.onAPIError,
      onCopyOrderError: this.onCopyOrderError,
    };

    const onScroll = this.state.deviceIndex === 0 ? {} : { onScroll: this.handleScroll };

    const hasChosenClientNumber = !this.state.userInfo.IsInternalUser || this.state.userInfo.ClientNumber !== '';

    if (this.state.isAppGoingToCrash) {
      return <CrashScreen />;
    }

    const prepaidStatus = this.getPrepaidStatus();

    return (
      <Router history={history}>
        <Suspense fallback={<Loader isSolidWhite />}>
          {shouldRedirectToLogin && <Redirect to="/login" />}
          {this.state.isLoggedIn || this.isPayingInvoice ? (
            <AppContext.Provider
              value={{
                setAppState: this.setAppState,
                isInternalUser: this.state.userInfo.IsInternalUser,
                isPrepaid: prepaidStatus,
                invoiceViaRpt:this.state.clients.invoiceViaRpt,
                clientNumber: this.state.userInfo.ClientNumber,
                isModalActive: this.state.isModalActive,
                isTutorialShowing: this.state.isTutorialShowing,
                isSupplyWarningON: this.state.isSupplyWarningON,
                isTemplateWarningON: this.state.isTemplateWarningON,
                isSubmissionWarningON: this.state.isSubmissionWarningON,
              }}
            >
              {shouldRedirectToLogin && <Redirect to="/login" />}
              {this.state.isLoggedIn && (
                <Loader isSmall={false} fadeOut={this.state.isInitialized} style={{ height: '0' }} />
              )}
              <ScrollToTop />
              <div
                id="app"
                className={classNames('app', {
                  'app--tutorial': this.state.isTutorialShowing,
                })}
              >
                {(this.state.isCreatingObject || this.state.isChangingObject || this.state.isGlobalLoaderShowing || this.state.isSamplesLoading) && (
                  <Loader dots={10} isSmall={false} />
                )}
                <Switch>
                  {/* Signout to user if they go on /login even if they have login tokens */}
                  {this.state.isLoggedIn && !this.state.isManuallyLoggedIn && (
                    <Route
                      exact
                      path="/(register|login|forgot)"
                      render={() => <Logout onLogout={this.handleLogout} />}
                    />
                  )}
                  <Route path="/PayInvoice" render={() => null} />
                  {this.state.isInitialized && (
                    <Route
                      path="*"
                      render={() => (
                        <Fragment>
                          <Nav
                            {...sharedProps}
                            filterFieldValue={this.state.filterFieldValue}
                            filterItemValue={this.state.filterItemValue}
                            isNavCollapsed={this.state.isNavCollapsed}
                            clientNumber={this.state.userInfo.ClientNumber}
                            clientNumberOptions={this.state.clients.options}
                            clients={this.state.clients}
                            userInfo={this.state.userInfo}
                            handleLogout={this.handleLogout}
                            submissionTypeOptions={this.state.submissionTypeOptions}
                            hasAcceptedTerms={this.state.hasAcceptedTerms}
                            filterFields={this.state.filterFields}
                            hasManageAccess={this.state.hasManageAccess}
                            hasLoginAsAdmin={this.state.hasLoginAsAdmin}
                          />
                        </Fragment>
                      )}
                    />
                  )}
                </Switch>

                <div
                  className={classNames('app__content', {
                    'app__content--collapsed': this.state.isNavCollapsed,
                    'app__content--mobile': this.state.deviceIndex === 0,
                  })}
                >
                  <div className="app__content__header">
                    <Switch>
                      <Route path="/login(.*)" render={() => null} />
                      <Route path="/payinvoice(.*)" render={() => null} />
                      {this.state.isInitialized && this.state.deviceIndex !== 0 && this.state.hasAcceptedTerms && (
                        <Route
                          path="/*"
                          render={() => (
                            <Dash
                              {...sharedProps}
                              submissionTypeOptions={this.state.submissionTypeOptions}
                              clients={this.state.clients}
                              isNavCollapsed={this.state.isNavCollapsed}
                              userInfo={this.state.userInfo}
                              handleLogout={this.handleLogout}
                              isLoggedInAsAdmin={this.state.isLoggedInAsAdmin}
                              filterFieldValue={this.state.filterFieldValue}
                              filterItemValue={this.state.filterItemValue}
                              hasManageAccess={this.state.hasManageAccess}
                              hasLoginAsAdmin={this.state.hasLoginAsAdmin}
                            />
                          )}
                        />
                      )}
                    </Switch>

                    {this.state.isInitialized && hasChosenClientNumber && this.state.hasAcceptedTerms && (
                      <Switch>
                        {this.state.deviceIndex === 1 && (
                          <Route
                            path="/(|overview|templates|supplies|jobs|invoices|submissions|additional-analysis|prepaidrequest|split-report)"
                            render={(props) => (
                              <Head
                                {...props}
                                {...sharedProps}
                                keys={tabs.keys.filter((x) => prepaidStatus || x !== 'Prepaid')}
                                tabs={tabs.tabs}
                                filterItemValue={this.state.filterItemValue}
                                headTitle={this.state.headTitle}
                                headSubTitle={this.state.headSubTitle}
                                headDescription={this.state.headDescription}
                              />
                            )}
                          />
                        )}
                        <Route
                          path="/(custom-reports|login-as-admin|terms|email-notifications|search-results|my-account|privacy|admin|manage-access/edit-information|manage-access/edit-access)"
                          render={(props) => (
                            <Head
                              {...sharedProps}
                              {...props}
                              hideTabs
                              headTitle={this.state.headTitle}
                              headSubTitle={this.state.headSubTitle}
                              headDescription={this.state.headDescription}
                            />
                          )}
                        />
                        <Route
                          path="/manage-access"
                          render={(props) => (
                            <Head
                              {...sharedProps}
                              {...props}
                              {...tabs.manageAccess}
                              headTitle={this.state.headTitle}
                              headSubTitle={this.state.headSubTitle}
                              headDescription={this.state.headDescription}
                            />
                          )}
                        />
                      </Switch>
                    )}
                  </div>
                  <div
                    className={`app__content__body ${
                      this.state.deviceIndex === 0 && this.state.isModalActive ? 'app__content__body--modal-open' : ''
                    }`}
                    {...onScroll}
                  >
                    <Switch>
                      {this.state.isInitialized && hasChosenClientNumber && (
                        <Fragment>
                          <Route
                            exact
                            path="/"
                            render={(props) => (
                              <Overview
                                {...sharedProps}
                                {...props}
                                templatesData={this.state.overviewTemplates}
                                jobsData={this.state.overviewJobs}
                                invoicesData={this.state.overviewInvoices}
                                ordersData={this.state.overviewOrders}
                                filterItemValue={this.state.filterItemValue}
                                setHeadTitle={this.setHeadTitle}
                                userName={this.state.userInfo.UserName}
                                hasAccessToInvoices={this.state.userInfo.HasAccessToInvoices}
                                IsInternalUser={this.state.userInfo.IsInternalUser}
                                isSupplyWarningON={this.state.isSupplyWarningON}
                                isTemplateWarningON={this.state.isTemplateWarningON}
                                isSubmissionWarningON={this.state.isSubmissionWarningON}
                                isPrepaid={prepaidStatus}
                                isFoodUser={this.state.userInfo.LOB==='F'}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/templates"
                            render={(props) => (
                              <Templates
                                {...sharedProps}
                                {...props}
                                data={this.state.templates}
                                filterItemValue={this.state.filterItemValue}
                                setHeadTitle={this.setHeadTitle}
                                userName={this.state.userInfo.UserName}
                                isSupplyWarningON={this.state.isSupplyWarningON}
                                isTemplateWarningON={this.state.isTemplateWarningON}
                                isSubmissionWarningON={this.state.isSubmissionWarningON}
                                isPrepaid={prepaidStatus}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/templates/new"
                            render={(props) => (
                              <Forms
                                {...sharedProps}
                                {...props}
                                userName={this.state.userInfo.UserName}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                formIndex={this.state.formIndex}
                                submissionTypes={this.state.submissionTypes}
                                submissionTypeOptions={this.state.submissionTypeOptions}
                                siteProvince={this.state.siteProvince}
                                siteProvinceOptions={this.state.siteProvinceOptions}
                                isTemplate
                                isNew
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                ShelfLifeStorageConditions={this.state.ShelfLifeStorageConditions}
                                isPrepaid={prepaidStatus}
                                prevTab={this.state.prevTab}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/templates/:templateId/edit"
                            render={(props) => (
                              <Forms
                                {...sharedProps}
                                userName={this.state.userInfo.UserName}
                                userLOB={this.state.userInfo.LOB}
                                {...props}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                formIndex={this.state.formIndex}
                                submissionTypeOptions={this.state.submissionTypeOptions}
                                submissionTypes={this.state.submissionTypes}
                                siteProvince={this.state.siteProvince}
                                siteProvinceOptions={this.state.siteProvinceOptions}
                                isTemplate
                                qcTypeOptions={this.state.QcTypeOptions}
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                serviceLevels={this.state.ServiceLevels}
                                ShelfLifeStorageConditions={this.state.ShelfLifeStorageConditions}
                                prevTab={this.state.prevTab}
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/split-report/new"
                            render={(props) => (
                              <SplitReportRequestForm
                                {...sharedProps}
                                userName={this.state.userInfo.UserName}
                                userLOB={this.state.userInfo.LOB}
                                {...props}
                                appState={this.state}
                                setAppState={this.setAppState}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                isSplitReport
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/split-report/edit/:requestNumber"
                            render={(props) => (
                              <SplitReportRequestForm
                                isSplitReport={true}
                                isEditing={true}
                                userName={this.state.userInfo.UserName}
                                userLOB={this.state.userInfo.LOB}
                                appState={this.state}
                                setAppState={this.setAppState}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                {...sharedProps}
                                {...props}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/additional-analysis/:aaId/edit"
                            render={(props) => (
                              <AdditionalAnalysis
                                {...sharedProps}
                                {...props}
                                setHeadTitle={this.setHeadTitle}
                                userInfo={this.state.userInfo}
                                userLOB={this.state.userInfo.LOB}
                                IsInternalUser={this.state.userInfo.IsInternalUser}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                submissionTypeOptions={this.state.submissionTypeOptions}
                                submissionTypes={this.state.submissionTypes}
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                serviceLevels={this.state.ServiceLevels}
                                ShelfLifeStorageConditions={this.state.ShelfLifeStorageConditions}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/additional-analysis/:aaId/confirmation"
                            render={(props) => (
                              <Confirmation
                                {...sharedProps}
                                {...props}
                                isAA
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/jobs"
                            render={(props) => (
                              <Jobs
                                {...sharedProps}
                                {...props}
                                data={this.state.jobs}
                                samples={this.state.samples}
                                receivedJobs={this.state.receivedJobs}
                                submittedJobsKeyPairs={this.state.submittedTab}
                                additionTabKeyPairs={this.state.additionTab}
                                filterItemValue={this.state.filterItemValue}
                                setHeadTitle={this.setHeadTitle}
                                userInfo={this.state.userInfo}
                                isSupplyWarningON={this.state.isSupplyWarningON}
                                isTemplateWarningON={this.state.isTemplateWarningON}
                                isSubmissionWarningON={this.state.isSubmissionWarningON}
                                isPrepaid={prepaidStatus}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/jobs/:jobId"
                            render={(props) => (
                              <JobsDetail
                                {...sharedProps}
                                {...props}
                                sampleDetails={this.state.sampleDetails}
                                jobDetails={this.state.jobDetails}
                                parameters={this.state.parameters}
                                jobFiles={this.state.jobFiles}
                                observations={this.state.observations}
                                isInternalUser={this.state.userInfo.IsInternalUser}
                                LOB={this.state.userInfo.LOB}
                                clientNumber={this.state.userInfo.ClientNumber}
                                serviceLevels={this.state.ServiceLevels}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/jobs/:jobId/confirmation"
                            render={(props) => (
                              <Confirmation
                                {...sharedProps}
                                {...props}
                                isJob
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/submissions"
                            render={() => {
                              history.push('/jobs');
                              return null;
                            }}
                          />
                          <Route
                            exact
                            path="/submissions/new"
                            render={(props) => (
                              <Forms
                                {...sharedProps}
                                {...props}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                formIndex={this.state.formIndex}
                                submissionTypes={this.state.submissionTypes}
                                submissionTypeOptions={this.state.submissionTypeOptions}
                                siteProvince={this.state.siteProvince}
                                siteProvinceOptions={this.state.siteProvinceOptions}
                                isSubmission
                                isNew
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                ShelfLifeStorageConditions={this.state.ShelfLifeStorageConditions}
                                prevTab={this.state.prevTab}
                                isPrepaidOrder={this.state.isPrepaidOrder}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/submissions/:submissionId/confirmation"
                            render={(props) => (
                              <Confirmation
                                {...sharedProps}
                                {...props}
                                isSubmission
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/submissions/:submissionId/edit"
                            render={(props) => (
                              <Forms
                                {...sharedProps}
                                {...props}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                userLOB={this.state.userInfo.LOB}
                                formIndex={this.state.formIndex}
                                submissionTypeOptions={this.state.submissionTypeOptions}
                                submissionTypes={this.state.submissionTypes}
                                siteProvince={this.state.siteProvince}
                                siteProvinceOptions={this.state.siteProvinceOptions}
                                isSubmission
                                qcTypeOptions={this.state.QcTypeOptions}
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                userInfo={this.state.userInfo}
                                serviceLevels={this.state.ServiceLevels}
                                ShelfLifeStorageConditions={this.state.ShelfLifeStorageConditions}
                                ChangeLogComments={this.state.ChangeLogComments}
                                prevTab={this.state.prevTab}
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/supplies"
                            render={(props) => (
                              <Supplies
                                {...sharedProps}
                                {...props}
                                data={this.state.orders}
                                setHeadTitle={this.setHeadTitle}
                                filterItemValue={this.state.filterItemValue}
                                ordersSearchKeyPairs={this.state.ordersSearch}
                                isSupplyWarningON={this.state.isSupplyWarningON}
                                isTemplateWarningON={this.state.isTemplateWarningON}
                                isSubmissionWarningON={this.state.isSubmissionWarningON}
                                isPrepaid={prepaidStatus}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/supplies/new"
                            render={(props) => (
                              <Forms
                                {...sharedProps}
                                {...props}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                formIndex={this.state.formIndex}
                                submissionTypes={this.state.submissionTypes}
                                submissionTypeOptions={this.state.submissionTypeOptions}
                                siteProvince={this.state.siteProvince}
                                siteProvinceOptions={this.state.siteProvinceOptions}
                                isOrder
                                isNew
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                ShelfLifeStorageConditions={this.state.ShelfLifeStorageConditions}
                                prevTab={this.state.prevTab}
                                prepaidOrderOverrideReason={this.state.PrepaidOrderOverrideReason }
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/supplies/:orderId/confirmation"
                            render={(props) => (
                              <Confirmation
                                {...sharedProps}
                                {...props}
                                isOrder
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/supplies/:orderId/edit"
                            render={(props) => (
                              <Forms
                                {...sharedProps}
                                {...props}
                                internalClientNumber={this.state.userInfo.ClientNumber}
                                clients={this.state.clients}
                                userInfo={this.state.userInfo}
                                formIndex={this.state.formIndex}
                                submissionTypeOptions={this.state.submissionTypeOptions}
                                submissionTypes={this.state.submissionTypes}
                                siteProvince={this.state.siteProvince}
                                siteProvinceOptions={this.state.siteProvinceOptions}
                                isOrder
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                orderSupplies={this.state.orderSupplies}
                                qcTypeOptions={this.state.QcTypeOptions}
                                ShelfLifeStorageConditions={this.state.ShelfLifeStorageConditions}
                                serviceLevels={this.state.ServiceLevels}
                                prevTab={this.state.prevTab}
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/invoices"
                            render={(props) => (
                              <Invoices
                                {...sharedProps}
                                {...props}
                                data={this.state.invoices}
                                invoiceJobs={this.state.invoiceJobs}
                                filterItemValue={this.state.filterItemValue}
                                setHeadTitle={this.setHeadTitle}
                                IsInternalUser={this.state.userInfo.IsInternalUser}
                                clientNumber={this.state.userInfo.ClientNumber}
                                hasAccessToInvoices={this.state.userInfo.HasAccessToInvoices}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/invoices/payment-summary"
                            render={(props) => (
                              <InvoicesPaymentSummary
                                {...sharedProps}
                                {...props}
                                selectedInvoices={this.state.invoices.selectedInvoices}
                                paySingleInvoice={this.state.invoices.paySingleInvoice}
                                singlePayInvoiceNumber={this.state.invoices.singlePayInvoiceNumber}
                                IsInternalUser={this.state.userInfo.IsInternalUser}
                                clientNumber={this.state.userInfo.ClientNumber}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/invoices/payment-details"
                            render={(props) => (
                              <InvoicesPaymentDetails
                                {...props}
                                {...sharedProps}
                                {...props}
                                selectedInvoices={this.state.invoices.selectedInvoices}
                                paySingleInvoice={this.state.invoices.paySingleInvoice}
                                singlePayInvoiceNumber={this.state.invoices.singlePayInvoiceNumber}
                                OrderId={this.state.invoices.OrderId}
                                IsInternalUser={this.state.userInfo.IsInternalUser}
                                clientNumber={this.state.userInfo.ClientNumber}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/invoices/payment-confirmation"
                            render={(props) => (
                              <InvoicesPaymentConfirmation
                                {...sharedProps}
                                {...props}
                                data={this.state.invoices}
                                clientNumber={this.state.userInfo.ClientNumber}
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/prepaidrequest"
                            render={(props) => (
                              <PrepaidRequest
                                {...sharedProps}
                                {...props}
                                data={this.state.prepaidrequest}
                                submittedJobsKeyPairs={this.state.submittedTab}
                                additionTabKeyPairs={this.state.additionTab}
                                prepaidAll={this.state.prepaidAll}
                                filterItemValue={this.state.filterItemValue}
                                setHeadTitle={this.setHeadTitle}
                                userInfo={this.state.userInfo}
                                isSupplyWarningON={this.state.isSupplyWarningON}
                                isTemplateWarningON={this.state.isTemplateWarningON}
                                isSubmissionWarningON={this.state.isSubmissionWarningON}
                                isPrepaid={prepaidStatus}
                              />
                            )}
                          />

                          <Route exact path="/privacy/" render={(props) => <Privacy {...sharedProps} {...props} />} />

                          <Route
                            exact
                            path="/my-account"
                            render={(props) => (
                              <MyAccount
                                {...sharedProps}
                                {...props}
                                userInfo={this.state.userInfo}
                                initialize={this.initialize}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/admin"
                            render={(props) => (
                              <LoginAsAdmin
                                {...sharedProps}
                                {...props}
                                clientNumber={this.state.userInfo.ClientNumber}
                                freshState={this.freshState}
                                initialize={this.initialize}
                              />
                            )}
                          />

                          <Route
                            exact
                            path="/email-notifications"
                            render={(props) => <EmailNotifications {...sharedProps} {...props} />}
                          />

                          {this.state.hasManageAccess ? (
                            <Fragment>
                              <Route
                                exact
                                path="/manage-access"
                                render={() => <Redirect to="/manage-access/current-users" />}
                              />
                              <Route
                                exact
                                path="/manage-access/current-users"
                                render={(props) => (
                                  <ManageAccessCurrentUsers
                                    {...sharedProps}
                                    {...props}
                                    userInfo={this.state.userInfo}
                                  />
                                )}
                              />
                              <Route
                                exact
                                path="/manage-access/edit-access/:id"
                                render={(props) => (
                                  <ManageAccessUserAccess {...sharedProps} {...props} userInfo={this.state.userInfo} />
                                )}
                              />
                              <Route
                                exact
                                path="/manage-access/edit-information/:id"
                                render={(props) => (
                                  <ManageAccessUser {...sharedProps} {...props} userInfo={this.state.userInfo} />
                                )}
                              />
                              <Route
                                exact
                                path="/manage-access/inactive-users"
                                render={(props) => (
                                  <ManageAccessInactiveUsers
                                    {...sharedProps}
                                    {...props}
                                    userInfo={this.state.userInfo}
                                  />
                                )}
                              />
                              <Route
                                exact
                                path="/manage-access/create-user"
                                render={(props) => (
                                  <ManageAccessUser {...sharedProps} {...props} userInfo={this.state.userInfo} isNew />
                                )}
                              />
                            </Fragment>
                          ) : (
                            <Route path="/manage-access" render={() => <Redirect to="/" />} />
                          )}

                          <Route
                            exact
                            path="/custom-reports"
                            render={(props) => <Reports {...sharedProps} {...props} />}
                          />
                          <Route
                            exact
                            path="/custom-reports/new"
                            render={(props) => (
                              <ReportsForm
                                {...sharedProps}
                                {...props}
                                clients={this.state.clients}
                                userInfo={this.state.userInfo}
                                reportJobs={this.state.reportJobs}
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/custom-reports/:id/copy"
                            render={(props) => (
                              <ReportsForm
                                {...sharedProps}
                                {...props}
                                clients={this.state.clients}
                                userInfo={this.state.userInfo}
                                reportJobs={this.state.reportJobs}
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                isCopying
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/custom-reports/:id/edit"
                            render={(props) => (
                              <ReportsForm
                                {...sharedProps}
                                {...props}
                                clients={this.state.clients}
                                userInfo={this.state.userInfo}
                                reportJobs={this.state.reportJobs}
                                isHeadButtonVisible={this.state.isHeadButtonVisible}
                                isEditing
                              />
                            )}
                          />

                          <Route exact path="/resources" render={() => <ResourcesIframe />} />
                        </Fragment>
                      )}
                    </Switch>
                    <Route
                      exact
                      path="/terms/"
                      render={(props) => (
                        <Terms
                          {...sharedProps}
                          {...props}
                          accepted={this.state.hasAcceptedTerms}
                          termsAndConditions={this.state.termsAndConditions}
                          setAppState={this.setAppState}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/PayInvoice/GetInvoice"
                      render={(props) => (
                        <InvoicesPaymentConfirmation
                          {...sharedProps}
                          {...props}
                          data={this.state.invoices}
                          clientNumber={this.state.userInfo.ClientNumber}
                          IsInternalUser={this.state.userInfo.IsInternalUser}
                          isPayingFromEmail
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/PayInvoice"
                      render={(props) => (
                        <InvoicesPaymentDetails
                          {...props}
                          {...sharedProps}
                          {...props}
                          selectedInvoices={this.state.invoices.selectedInvoices}
                          clientNumber={this.state.userInfo.ClientNumber}
                          IsInternalUser={this.state.userInfo.IsInternalUser}
                          paySingleInvoice={this.state.invoices.paySingleInvoice}
                          singlePayInvoiceNumber={this.state.invoices.singlePayInvoiceNumber}
                          OrderId={this.state.invoices.OrderId}
                          isPayingFromEmail
                        />
                      )}
                    />

                    {!hasChosenClientNumber && this.state.hasAcceptedTerms && <NoClient />}
                  </div>
                  {this.state.isInitialized && !this.isPayingInvoice && this.state.deviceIndex === 1 && (
                    <Footer {...sharedProps} footerDesktopExpanded={this.state.footerDesktopExpanded} />
                  )}
                </div>
            
                <ApiErrorModal
                  show={this.state.isAPIErrorModalOpen}
                  setAppState={this.setAppState}
                  errorMessage={this.state.apiErrorMessage}
                  isCloseable={this.state.isApiErrorModalCloseable}
                  hidePageUnavailableDescription={
                    this.state.apiErrorMessage === null || this.state.hidePageErrorDiscription === true
                  }
                  shouldRedirectToBV={this.state.shouldRedirectToBV}
                />
                {this.state.settingTableCode !== null && this.state.deviceIndex === 1 && (
                  <Modal show>
                    <EditColumns
                      setAppState={this.setAppState}
                      table={this.state[this.state.settingTableCode]}
                      settingTableCode={this.state.settingTableCode}
                    />
                  </Modal>
                )}
                {this.state.shareCode !== null && this.state.shareId !== null && (
                  <ShareModal
                    shareId={this.state.shareId}
                    shareCode={this.state.shareCode}
                    setAppState={this.setAppState}
                    clientNumber={this.state.userInfo.ClientNumber}
                    isInternalUser={this.state.userInfo.IsInternalUser}
                    isMobile={this.state.deviceIndex === 0}
                  />
                )}
                <NotifyContainer />
              </div>
            </AppContext.Provider>
          ) : (
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <LoginLayout>
                <Route
                  exact
                  path="/login"
                  render={(props) => <Login {...props} onLogin={this.handleLogin} onLogout={this.handleLogout} />}
                />
                <Route exact path="/forgot" render={(props) => <ForgotPassword {...props} />} />
                <Route exact path="/register" render={(props) => <Registration {...props} />} />
              </LoginLayout>
            </ThemeProvider>
          )}
        </Suspense>
      </Router>
    );
  }
}

App.propTypes = {
  loadAppConfig: PropTypes.func,
  loadSubmissionTypes: PropTypes.func,
  loadUserInfo: PropTypes.func,
};

export default connect(null, {
  loadAppConfig,
  loadSubmissionTypes,
  loadUserInfo,
})(hot(module)(App));



// WEBPACK FOOTER //
// ./src/App.jsx